require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-civil-society-provides-feedback-on-the-external-re.json") })
        }
      }, "path---en-us-update-civil-society-provides-feedback-on-the-external-re");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-civil-society-provides-feedback-on-the-external-re!./.cache/json/en-us-update-civil-society-provides-feedback-on-the-external-re.json
// module id = 639
// module chunks = 231608221292675